// extracted by mini-css-extract-plugin
export default {"fullWidth":"Button_fullWidth__SuzbM","buttonSolid":"Button_buttonSolid__wIEyr","buttonOutline":"Button_buttonOutline__BcFVN"};